var MessageSources = ['YandexTrustPaymentForm', 'YandexTrustBindingForm'];
function parseMessageData(data) {
    if (typeof data === 'string') {
        try {
            return JSON.parse(data);
        }
        catch (e) {
            return {};
        }
    }
    return data;
}
export default function getPaymentMessage(messageData) {
    var data = parseMessageData(messageData);
    return MessageSources.includes(data === null || data === void 0 ? void 0 : data.source)
        ? data
        : { type: '', source: '', data: {} };
}
